<!-- Migrated from legacy/Plus/Plus/timeline/index.shtml -->

<template>
  <img class="banner" src="/Plus/Timeline/Banner.jpg" alt="Collage of VizbiPlus images" />
  <h4>Timeline</h4>
  <table>
    <tbody>
      <tr v-for="(milestone, index) in timeline" :key="index">
        <th>{{ milestone.year || "" }}</th>
        <td class="date">{{ formatDate(milestone.date) }}</td>
        <td class="thumbnail">
          <a
            v-if="milestone.thumbnail"
            :href="imageFor(milestone)"
            :title="milestone.caption">
            <img :src="`/Plus/Timeline/${milestone.thumbnail}`" :alt="milestone.caption" />
          </a>
        </td>
        <!-- eslint-disable-next-line vue/no-v-html -- trusted static content -->
        <td v-html="milestone.text" />
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import timeline from "@/assets/plus/timeline";
const formatDate = (date) => date.replace("&ndash;", "–");
const imageFor = (milestone) => {
  if (milestone.image) return milestone.image;
  return `/Plus/Timeline/${milestone.thumbnail.replace("-small", "").replace("_small", "")}`;
};
</script>

<style scoped>
img.banner {
  max-width: 100%;
  border-radius: 4px;
}
table {
  border-spacing: 0 8px;
  width: 100%;
}
th {
  font-size: 1.2rem;
  text-align: left;
  vertical-align: top;
  width: 3.5rem;
}
td.date {
  color: var(--subtitle-color);
  font-weight: 600;
  vertical-align: top;
  width: 8rem;
}
td.thumbnail {
  vertical-align: top;
  width: 160px;
}
td.thumbnail img {
  width: 150px;
  border-radius: 4px;
}
td {
  padding: 0 8px 8px 0;
  vertical-align: top;
}
</style>
